import { TrackInfo } from './model/track-info';
import { TrackActionResult } from './model/track-action-result';
import { TrackTypes } from './model/track-types';
import {CacheService} from "../../comunicator-native/cache/v2/cache.service";

export abstract class JourneyTrack {

  track: TrackInfo[];

  abstract getTrack(): TrackInfo[];

  abstract getName(): TrackTypes

  abstract loadData(cacheService?: CacheService): Promise<any>;

  getIndexPage(pageId: string, path: string): number {
    const stepArray = this.track.filter(trackInfo => trackInfo.path[0] === path);
    return stepArray.findIndex(trackInfo => trackInfo.pageId === pageId) + 1;
  }

  getTotalPage(path: string): number {
    return this.track.filter(trackInfo => trackInfo.path[0] === path).length;
  }

  abstract executeAction(actionName, data): TrackActionResult
  
  abstract isUncoupled()

  abstract isEventComunicator()

  abstract isBackHeader()
  
}
